import { render } from "./json-editor.vue?vue&type=template&id=7f06a0a8&ts=true"
import script from "./json-editor.ts?vue&type=script&lang=ts"
export * from "./json-editor.ts?vue&type=script&lang=ts"

import "./json-editor.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__